<template>
  <router-link :to="route" class="appointment-list-item">
    <div class="cel">
      <h6 class="service">{{ service.name }}</h6>
      <small>{{ optionTitle }}</small>
      <div class="provider">
        <h6 class="name">
          <small>
            ผู้ให้บริการ
            <strong>{{ provider.name }}</strong>
          </small>
        </h6>
      </div>
    </div>
    <h6 class="home">{{ packageName }}</h6>
    <h6 class="home">
      {{ home.address }}
      <br />
      <small>{{ home.project }}</small>
      <br />
      <small>{{ homeContact }}</small>
    </h6>
    <h6 class="date-time">
      {{ dateText }}
      <br />
      <small>{{ timeText }}</small>
    </h6>
    <h6 class="date-time">{{ creationDateText }}</h6>
    <div :class="statusClassList" class="status">{{ statusText }}</div>
  </router-link>
</template>

<script>
import { toLocaleTH, getAppointmentTimeText } from "@/lib/dateTime";

export default {
  components: {},
  props: {
    service: { type: Object, default: null },
    provider: { type: Object, default: null },
    dateTime: { type: [String, Object], default: null },
    home: { type: Object, default: null },
    status: { type: String, default: null },
    createdAt: { type: [String, Object], default: null },
    route: { type: Object, default: null },
    packageName: { type: String, default: null },
    mainOption: { type: String, default: null },
    extraOption: { type: String, default: null },
    appointmentDurationTime: { type: String, default: null }
  },
  computed: {
    dateTimeTH() {
      return this.dateTime ? toLocaleTH(this.dateTime) : undefined;
    },
    dateText() {
      return this.dateTimeTH && this.dateTimeTH.isValid
        ? this.dateTimeTH.toFormat("dd MMMM yyyy")
        : "-";
    },
    creationDateText() {
      return this.createdAt && this.dateTimeTH && this.dateTimeTH.isValid
      ? toLocaleTH(this.createdAt).toFormat("dd MMMM yyyy HH:mm น.")
      : "-";
    },
    timeText() {
      if (this.appointmentDurationTime) return this.appointmentDurationTime;
      if (!this.dateTime || !this.dateTime.isValid) return "";

      return getAppointmentTimeText(this.dateTime);
    },
    homeContact() {
      return `${this.home.contact.name}  (${this.home.contact.phoneNumber})`;
    },
    statusText() {
      const statusMap = {
        EMPTY: "รอนัดหมาย",
        CREATED: "รอผู้ให้บริการยืนยัน",
        CONFIRMED: "รอรับบริการ",
        WAIT_CONFIRMED_SERVICE_COMPLETE: "รอรับบริการ",
        CANCELLED: "ถูกยกเลิก",
        FULFILLED: "เสร็จสิ้น"
      };

      return statusMap[this.status];
    },
    statusClassList() {
      return [this.status.toLowerCase()];
    },
    optionTitle() {
      if (this.mainOption && this.extraOption) {
        return `${this.mainOption}, ${this.extraOption}`;
      } if (this.mainOption) {
        return this.mainOption;
      }
      return undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.appointment-list-item {
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 2fr 1.5fr 1fr 1fr 1fr;
  grid-gap: 10px;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  &:hover {
    color: inherit;
    text-decoration: none;
    background: #fafafa;
  }
}

.service + .provider {
  margin-top: 6px;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
  }
}

.status {
  text-align: center;

  &.empty {
    color: $secondary-color;
  }

  &.created {
    color: $secondary-color;
  }

  &.cancelled {
    color: $danger-color;
  }

  &.confirmed {
    color: $warning-color;
  }

  &.wait_confirmed_service_complete {
    color: $warning-color;
  }

  &.fulfilled {
    color: $success-color;
  }
}

.date-time,
.service,
.provider > .name,
.home,
.status {
  margin: 0;
  font-size: 0.9rem;
}
</style>
